export const validations = {
  exceedsMaximumRange: "Must not exceed the maximum range",
  isLowerThanMinimumRange: "Must be greater than the minimum range"
};
